import { CoreImageView } from '@core/widgets';
import { TViewCommonOption } from '@libs/types';
import clsx from 'clsx';
import React from 'react';
import { getInlineStyles } from '../../../utils/styles';
import styles from './pngIcon.module.css';

const URL_IMAGES_FLAG = `${process.env.NX_PUBLIC_CLOUD_PAYSEND_API}/images/web/flag-icons`;
type TSize = '16px' | '20px' | '24px' | '40px' | '80px';

function getSize(size?: TSize) {
    switch (size) {
        case '16px':
            return '16px';
        case '20px':
            return '20px';
        case '24px':
            return '24px';
        case '40px':
            return '40px';
        case '80px':
            return '80px';
        default:
            return '24px';
    }
}

type IFlagIconProps = {
    name?: string;
    size?: TSize;
    rightMargin?: boolean;
    defaultIcon?: string;
    fill?: string;
} & Pick<TViewCommonOption, 'style' | 'styleName' | 'parentStyleNames' | 'isDisabled'>;

const FlagIcon: React.FC<IFlagIconProps> = ({
    name,
    defaultIcon,
    fill,
    isDisabled = false,
    size = '24px',
    rightMargin = false,
    parentStyleNames,
    styleName,
}) => {
    if (name) {
        const sizeNum = parseInt(getSize(size), 10);
        return (
            <span
                className={clsx(styles.pngIcon, isDisabled && styles.disabled, rightMargin && styles.rightMargin)}
                style={getInlineStyles({ variables: { size: getSize(size) } })}
            >
                <CoreImageView
                    src={`${URL_IMAGES_FLAG}/${name}.png`}
                    isDisabled={isDisabled}
                    styleProps={{ width: sizeNum, height: sizeNum, objectFit: 'cover', iconColor: fill }}
                    defaultSrc={defaultIcon}
                    parentStyleNames={parentStyleNames}
                    styleName={styleName}
                />
            </span>
        );
    }
    return null;
};
export { FlagIcon };
